export const MetamaskSvg = () => {
  return (
    <svg
      width="23"
      height="23"
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.7875 2.56274L12.6045 7.89765L13.9328 4.75013L19.7875 2.56274Z"
        fill="#E2761B"
        stroke="#E2761B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.20508 2.56274L10.3303 7.94818L9.06697 4.75013L3.20508 2.56274Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2031 14.9291L15.29 17.86L19.3833 18.9862L20.56 14.994L17.2031 14.9291Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.44727 14.994L3.61676 18.9862L7.70998 17.86L5.79692 14.9291L2.44727 14.994Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.47851 9.97672L6.33789 11.7021L10.4022 11.8826L10.2579 7.51501L7.47851 9.97672Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5138 9.97672L12.6983 7.46448L12.6045 11.8826L16.6616 11.7021L15.5138 9.97672Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.70996 17.8599L10.15 16.6688L8.04204 15.0228L7.70996 17.8599Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8428 16.6688L15.29 17.8599L14.9507 15.0228L12.8428 16.6688Z"
        fill="#E4761B"
        stroke="#E4761B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.29 17.86L12.8428 16.6688L13.0377 18.2642L13.016 18.9356L15.29 17.86Z"
        fill="#D7C1B3"
        stroke="#D7C1B3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.70996 17.86L9.98397 18.9356L9.96953 18.2642L10.15 16.6688L7.70996 17.86Z"
        fill="#D7C1B3"
        stroke="#D7C1B3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.0202 13.9689L7.98438 13.3697L9.42097 12.7128L10.0202 13.9689Z"
        fill="#233447"
        stroke="#233447"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9727 13.9689L13.5718 12.7128L15.0157 13.3697L12.9727 13.9689Z"
        fill="#233447"
        stroke="#233447"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.70993 17.86L8.05645 14.9291L5.79688 14.994L7.70993 17.86Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.9434 14.9291L15.2899 17.86L17.2029 14.994L14.9434 14.9291Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.6616 11.7021L12.6045 11.8826L12.9799 13.9689L13.5791 12.7128L15.0229 13.3698L16.6616 11.7021Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.98384 13.3698L9.42766 12.7128L10.0196 13.9689L10.4022 11.8826L6.33789 11.7021L7.98384 13.3698Z"
        fill="#CD6116"
        stroke="#CD6116"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.33789 11.7021L8.04159 15.0229L7.98384 13.3698L6.33789 11.7021Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.0224 13.3698L14.9502 15.0229L16.6611 11.7021L15.0224 13.3698Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4021 11.8826L10.0195 13.9689L10.496 16.4306L10.6043 13.1892L10.4021 11.8826Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6041 11.8826L12.4092 13.182L12.4958 16.4306L12.9795 13.9689L12.6041 11.8826Z"
        fill="#E4751F"
        stroke="#E4751F"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.9798 13.9689L12.4961 16.4306L12.8426 16.6689L14.9506 15.0229L15.0228 13.3698L12.9798 13.9689Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.98438 13.3698L8.04213 15.0229L10.1501 16.6689L10.4966 16.4306L10.0202 13.9689L7.98438 13.3698Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.016 18.9356L13.0376 18.2643L12.8572 18.1054H10.1356L9.96953 18.2643L9.98397 18.9356L7.70996 17.86L8.50406 18.5097L10.1139 19.6287H12.8788L14.4959 18.5097L15.29 17.86L13.016 18.9356Z"
        fill="#C0AD9E"
        stroke="#C0AD9E"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.8429 16.6689L12.4964 16.4307H10.4967L10.1502 16.6689L9.96973 18.2643L10.1358 18.1055H12.8574L13.0378 18.2643L12.8429 16.6689Z"
        fill="#161616"
        stroke="#161616"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.0907 8.24416L20.7044 5.29878L19.7875 2.56274L12.8428 7.71717L15.5138 9.97674L19.2894 11.0813L20.1268 10.1067L19.7659 9.8468L20.3434 9.31981L19.8958 8.97329L20.4733 8.53293L20.0907 8.24416Z"
        fill="#763D16"
        stroke="#763D16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.2959 5.29878L2.90952 8.24416L2.51969 8.53293L3.09722 8.97329L2.65685 9.31981L3.23438 9.8468L2.87343 10.1067L3.70362 11.0813L7.4792 9.97674L10.1503 7.71717L3.2055 2.56274L2.2959 5.29878Z"
        fill="#763D16"
        stroke="#763D16"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.2898 11.0813L15.5143 9.97681L16.6621 11.7022L14.9512 15.0229L17.2035 14.9941H20.5604L19.2898 11.0813Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.47897 9.97681L3.70339 11.0813L2.44727 14.9941H5.79692L8.04205 15.0229L6.33835 11.7022L7.47897 9.97681Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6047 11.8826L12.843 7.71716L13.9403 4.75012H9.06738L10.1502 7.71716L10.4029 11.8826L10.4895 13.1964L10.4968 16.4306H12.4964L12.5109 13.1964L12.6047 11.8826Z"
        fill="#F6851B"
        stroke="#F6851B"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const MoonSvg = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4947 17.3538L19.4884 18.3538C19.4959 18.3538 19.5033 18.3538 19.5108 18.3537L19.4947 17.3538ZM12.6604 22L12.6397 22.9998C12.6458 22.9999 12.6518 22.9999 12.6578 23L12.6604 22ZM20.4002 18.1116L19.6006 17.5112L20.4002 18.1116ZM10.6394 2.9735L9.73164 2.55399L10.6394 2.9735ZM19.5009 16.3538C17.9339 16.3441 16.3962 15.9086 15.0454 15.0903L14.0091 16.8009C15.6669 17.8052 17.5581 18.3417 19.4884 18.3538L19.5009 16.3538ZM15.0454 15.0903C13.6944 14.2718 12.578 13.0993 11.8129 11.6906L10.0554 12.6452C10.9877 14.3617 12.3515 15.7967 14.0091 16.8009L15.0454 15.0903ZM11.8129 11.6906C11.0477 10.2818 10.6621 8.68873 10.6972 7.07509L8.69763 7.03164C8.65504 8.99151 9.12313 10.9288 10.0554 12.6452L11.8129 11.6906ZM10.6972 7.07509C10.725 5.79596 11.0163 4.54174 11.5471 3.39302L9.73164 2.55399C9.08523 3.9527 8.7314 5.47779 8.69763 7.03164L10.6972 7.07509ZM9.79634 1.29807C7.61281 1.9529 5.67814 3.29385 4.27509 5.14097L5.86774 6.35072C7.01683 4.83793 8.59625 3.74597 10.3709 3.21378L9.79634 1.29807ZM4.27509 5.14097C2.62387 7.31481 1.82583 10.0354 2.03188 12.773L4.02624 12.6229C3.85653 10.3681 4.5146 8.13213 5.86774 6.35072L4.27509 5.14097ZM2.03188 12.773C2.23794 15.5108 3.434 18.0763 5.39306 19.9684L6.78246 18.5298C5.18062 16.9828 4.19594 14.8776 4.02624 12.6229L2.03188 12.773ZM5.39306 19.9684C7.35271 21.861 9.93567 22.9438 12.6397 22.9998L12.6811 21.0002C10.4868 20.9548 8.38372 20.0763 6.78246 18.5298L5.39306 19.9684ZM12.6578 23C14.5099 23.0048 16.3306 22.5204 17.9431 21.5952L16.9479 19.8605C15.6381 20.6119 14.1622 21.0039 12.663 21L12.6578 23ZM17.9431 21.5952C19.2135 20.8664 20.3201 19.8839 21.1999 18.712L19.6006 17.5112C18.8819 18.4684 17.98 19.2683 16.9479 19.8605L17.9431 21.5952ZM19.869 16.3392C19.739 16.3469 19.6088 16.3519 19.4786 16.354L19.5108 18.3537C19.67 18.3511 19.8291 18.3451 19.988 18.3356L19.869 16.3392ZM21.1999 18.712C21.6059 18.1714 21.5562 17.5171 21.2666 17.0557C20.9872 16.6105 20.4675 16.3035 19.869 16.3392L19.988 18.3356C19.8146 18.346 19.6586 18.2558 19.5727 18.1189C19.5281 18.0479 19.493 17.95 19.4942 17.8327C19.4956 17.7087 19.5376 17.595 19.6006 17.5112L21.1999 18.712ZM11.5471 3.39302C11.8008 2.8441 11.7007 2.24339 11.3821 1.8205C11.0515 1.38156 10.4504 1.10192 9.79634 1.29807L10.3709 3.21378C10.27 3.24404 10.147 3.24425 10.0283 3.20116C9.91607 3.16044 9.8358 3.09176 9.78467 3.02388C9.68618 2.89313 9.65819 2.71291 9.73164 2.55399L11.5471 3.39302Z"
        fill="#CCCCCC"
      />
    </svg>
  );
};

export const BurnSvg = () => {
  return (
    <svg
      width="19"
      height="22"
      viewBox="0 0 19 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.68631 17.7432L3.52237 18.5799C5.14776 20.2067 7.28229 21.0134 9.41259 20.9998C11.4736 20.9612 13.5229 20.1549 15.0957 18.5808L15.9177 17.7582C18.4002 14.5185 18.1601 9.86015 15.1974 6.89489L9.77523 1.46806C9.61239 1.30508 9.29607 1.43048 9.26668 1.65898C9.18887 2.26385 8.97302 3.2654 8.38462 4.58116C7.37842 6.83116 6.07692 11 4.23077 10.5C2.84615 10 5.62384 5.24428 4.23077 6.08116C3.85286 6.30819 3.41801 6.89462 3.41801 6.89462C0.459611 9.85555 0.216084 14.5037 2.68631 17.7432Z"
        stroke="#CCCCCC"
        strokeWidth="1.5"
      />
      <path
        d="M6.73242 19.047L7.0582 19.3999C7.69028 20.0847 8.52035 20.4242 9.34877 20.4185C10.1502 20.4022 10.9471 20.0628 11.5587 19.4003L11.879 19.0533C12.8439 17.6897 12.7503 15.7293 11.5984 14.4814L9.30787 12L7.01746 14.4813C5.8672 15.7274 5.77233 17.6835 6.73242 19.047Z"
        stroke="#CCCCCC"
        strokeWidth="1.5"
      />
    </svg>
  );
}

export const FavouriteIcon = () => {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 49.4085L24.6166 46.3285C12.6 35.4318 4.66663 28.2451 4.66663 19.4251C4.66663 12.2385 10.3133 6.5918 17.5 6.5918C21.56 6.5918 25.4566 8.4818 28 11.4685C30.5433 8.4818 34.44 6.5918 38.5 6.5918C45.6866 6.5918 51.3333 12.2385 51.3333 19.4251C51.3333 28.2451 43.4 35.4318 31.3833 46.3518L28 49.4085Z"
        fill="#C51010"
        stroke="black"
      />
    </svg>
  );
}